module.exports = "/img/10.2c7b73.webp";